import { Button, ButtonGroup } from "react-bootstrap"
import { PhotoGallery } from "../UI/PhotoGallery"
import { useTranslation } from "react-i18next";


export const Bars = ({ selLanguage, reserFormShow, setReserFormShow }) => {

    const [t] = useTranslation("global");

    const photosBlack = [
        { src: "/AboutProjcet/091A8275.jpg", width: 2500, height: 1667, alt: "Черный бар Лениград Центра" },
        { src: "/AboutProjcet/091A8278.jpg", width: 2500, height: 1667, alt: "Черный бар Лениград Центра" },
        { src: "/AboutProjcet/091A8303.jpg", width: 2500, height: 1667, alt: "Черный бар Лениград Центра" },
    ]
    const photosWhite = [
        { src: "/AboutProjcet/091A8242-1.jpg", width: 2500, height: 1667, alt: "Белый бар Лениград Центра" },
        { src: "/AboutProjcet/091A8245-1.jpg", width: 2500, height: 1667, alt: "Белый бар Лениград Центра" },
        { src: "/AboutProjcet/091A8242-1.jpg", width: 2500, height: 1667, alt: "Белый бар Лениград Центра" },
    ]
    return (
        <>
            <div>
                <ButtonGroup className="mb-3">
                    {/* <Button size="sm" variant="light" className="btn-lc">{t("general.blackMenu")}</Button> */}
                    <Button size="sm" href="https://leningradcenter.ru/api/redirecturls/menu-bar" target="_blank" variant="light" className="btn-lc">{t("general.barMenu")}</Button>
                    {/* <Button size="sm" variant="light" className="btn-lc"></Button> */}
                </ButtonGroup>
            </div>
            <div>
                <ButtonGroup className="mb-3">
                    {/* <Button size="sm" variant="light" className="btn-lc">{t("general.blackMenu")}</Button> */}
                    <Button size="sm" onClick={() => { setReserFormShow(!reserFormShow) }} variant="light" className="btn-lc">{t("menu.reservation")}</Button>
                    {/* <Button size="sm" variant="light" className="btn-lc"></Button> */}
                </ButtonGroup>
            </div>
            {selLanguage === "en" ?
                <>
                    <h2>Black bar</h2>
                    <p>
                        The Black Bar Leningrad Centre is located to the right of the Main Stage – and from the moment you step inside, it makes its presence known as a place with character. Valentin Yudashkin worked on its interior design, and this is evident in every detail: metal contrasts with crystal, leather with deep velvet, darkness with light. The result is a space that you want to look at. The space is infused with a theatrical backstage atmosphere: sometimes artists appear in the bar before the start of the show, and you suddenly find yourself not merely a spectator but part of what is about to transpire on stage.
                    </p>
                    <p>
                        The cocktail menu is its own art form. The signature mixes here are created without regard to standards, and if you don't want to part with your glass before the bell rings, it will be served directly to your table in the hall.
                    </p>
                </>
                :
                <>
                    <h2>Черный бар</h2>
                    <p>
                        Черный бар Ленинград Центра расположен справа от Основной сцены — и уже с порога заявляет о себе как о месте с характером. Над его интерьером работал Валентин Юдашкин, и здесь это чувствуется в каждой детали: металл спорит с хрусталем, кожа — с глубоким бархатом, темнота — со светом. Получается пространство, которое хочется разглядывать. Здесь царит атмосфера театрального закулисья — иногда перед началом шоу в баре появляются артисты, и ты вдруг оказываешься не просто зрителем, а частью того, что вот-вот начнется на сцене.
                    </p>
                    <p>
                        Коктейльная карта — отдельное искусство. Авторские миксы здесь придумывают без оглядки на стандарты, а если не хочется расставаться с бокалом до звонка, его подадут прямо к столику в зале.
                    </p>
                </>
            }
            <div className="mb-3">
                <PhotoGallery photos={photosBlack} />
            </div>
            {
                selLanguage === "en" ?
                    <>
                        <h2>White bar</h2>
                        <p>
                            The White Bar Leningrad Centre is located in the left wing of the theatre hall. This is also the work of Valentin Yudashkin, but it's a completely different story: no mystery, just light, mirrors and formal elegance. The interior plays on the theme of dressing rooms – as if the performers have just left the stage and are about to return.
                        </p>
                        <p>
                            During intermissions, calm music plays here, and exquisite aperitifs are served in glasses, which, as in the Black Bar, can be taken with you to the auditorium.
                        </p>
                        <p>
                            But the main reason people come here is for the unique concert life. On certain days, the White Bar turns into an intimate stage for the fashion band Chanel Gangsters. The project was born right here, from spontaneous musical evenings, and over time grew into full-fledged concerts with a unique signature style. In their performances, jazz meets electronica, improvisation mixes with drama, and the musicians themselves put on a show that's just as spectacular as the one on the Main Stage. It's a reason to visit Leningrad Centre all on its own.
                        </p>
                    </>
                    :
                    <>
                        <h2>Белый бар</h2>
                        <p>
                            Белый бар Ленинград Центра расположен в левом крыле театрального зала. Это тоже работа Валентина Юдашкина, но совсем другая история: никакой таинственности, только свет, зеркала и парадная элегантность. Интерьер обыгрывает тему гримерных — словно артисты только что вышли на сцену и вот-вот вернутся.
                        </p>
                        <p>
                            В антрактах здесь играет спокойная музыка, а в бокалах — изысканные аперитивы, которые, как и в Черном баре, можно забрать с собой в зрительный зал.
                        </p>
                        <p>
                            Но главное, ради чего сюда приходят, — отдельная концертная жизнь. В определенные дни Белый бар превращается в камерную сцену для фешн-бенда «Шанель гангстерз». Проект родился прямо здесь, из спонтанных музыкальных вечеров, и со временем вырос в полноценные концерты со своим почерком. В их выступлениях джаз встречается с электроникой, импровизация — с драматургией, а сами музыканты устраивают перформанс, который по зрелищности не уступает шоу на Основной сцене. Это отдельный повод прийти в Ленинград Центр.
                        </p>
                    </>
            }
            <div className="mb-3">
                <PhotoGallery photos={photosWhite} />
            </div>
        </>
    )
}